import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Table from "../../../../../components/coreUiTable/Table";
import {
  XLSX,
  dataForTables,
  getFormattedData,
  getScopedSlots,
  makeColHeadersUnique
} from "../utils/dataForTables";

export const RevenueTable = () => {
  const { data, colHeaders, columns } = useSelector(
    (state) => state.multiLocation.allRevenue.tableInfo
  );

  /*extract currency symbol from columns first object*/
  let pattern = columns[1].numericFormat?.pattern;
  let currency = pattern && pattern.replace("0,0.00", "");

  let formattedData = getFormattedData(data, currency);
  let headers = makeColHeadersUnique(colHeaders);
  let scopedSlots = getScopedSlots(data, headers);

  useEffect(() => {
    const tables = document.querySelectorAll(".table-responsive");

    const revenueTableHeight = tables[0].scrollHeight;

    if (revenueTableHeight > 700) {
      tables.forEach((table) => {
        table.style.width = table.offsetWidth + 8 + "px";
      });
    }
  }, []);

  return (
    <>
      <XLSX colHeaders={colHeaders} data={data} columns={columns} />
      <Table
        cName={"revenueTable"}
        overrideColumnCallback={(header, index) => ({
          _style: header === "Location" ? { width: "230px" } : {},
          label: colHeaders[index]
        })}
        table={{ data: formattedData, colHeaders: headers }}
        scopedSlots={scopedSlots}
        {...dataForTables}
      />
    </>
  );
};
export default RevenueTable;
